import { render } from "./MovimientosInternos.vue?vue&type=template&id=a390b3bc&scoped=true"
import script from "./MovimientosInternos.vue?vue&type=script&lang=js"
export * from "./MovimientosInternos.vue?vue&type=script&lang=js"

import "./MovimientosInternos.vue?vue&type=style&index=0&id=a390b3bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a390b3bc"]])

export default __exports__